import Papa from 'papaparse';

export default {
    state: {
        parsed: {
            meta: {
                fields: null,
            },
            data: null,
        },
    },

    getters: {
        parsed: state => !!state.parsed.data,

        importedColumns: (state, getters) => {
            if (getters.parsed) {
                return state.parsed.meta.fields.filter(field => !!field);
            }
        },
    },

    actions: {
        parseData({ commit }, fileInput) {
            return new Promise(resolve => {
                Papa.parse(fileInput, {
                    header: true,
                    skipEmptyLines: true,
                    complete(parsed) {
                        commit('SET_PARSED_DATA', parsed);
                        resolve();
                    },
                });
            });
        },

        reset({ commit }) {
            commit('RESET');
        },
    },

    mutations: {
        SET_PARSED_DATA(state, data) {
            state.parsed = data;
        },

        RESET(state) {
            state.parsed = {
                meta: {
                    fields: null,
                },
                data: null,
            };
        },
    },
};
